import { createContext, useContext, ReactElement } from 'react'
import { AppState, useAppReducer } from '../reducers/App'

export const AppContext = createContext<AppState | undefined>(undefined)

export const AppProvider = ({
  children,
  ...rest
}: {
  [x: string]: unknown
  children: ReactElement | ReactElement[]
}) => {
  const [state, dispatch] = useAppReducer()

  return (
    <AppContext.Provider
      value={{
        ...state,
        dispatch
      }}
      {...rest}
    >
      {children}
    </AppContext.Provider>
  )
}

// custom hook to create App context
export const useAppContext = () => {
  const context = useContext(AppContext)
  if (!context) {
    throw new Error('App components cannot be rendered outside the LocationDetailsProvider components')
  }
  return context
}
